// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3J1RB","header":"MergedInvoice_header__RDKA7"};